import { Button } from '@timelyapp/react';
import AppLinkButton from 'components/AppLinkButton';
import SuperModal, { ModalContent, ModalHeader, ModalHeaderGroup } from 'components/modals';
import React from 'react';
import styles from 'routes/users/components/UnoccupiedSeatsWarningModal/UnoccupiedSeatsWarningModal.module.scss';

interface Props {
  projectId: number | null;
  isOpen: boolean;
  onClose: () => void;
}

const ProjectRateChangeWarning: React.FC<Props> = ({ isOpen, onClose, projectId }) => {
  return (
    <SuperModal
      isOpen={isOpen}
      shouldFocusAfterRender
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      zIndex={1199}
      alwaysOverlayNavbar={true}
    >
      <div className={styles.container}>
        <ModalHeader>
          <ModalHeaderGroup autoGrow title>
            Project rates
          </ModalHeaderGroup>
        </ModalHeader>
        <ModalContent>
          <p>
            Updates to project rates on this page will apply to new and existing time entries that
            are unbilled. Edit a project directly to change project rates for new entries only.
          </p>
          <div className={styles.buttons}>
            <Button priority="xhigh" onClick={onClose}>
              Got it
            </Button>
            <AppLinkButton onClick={onClose} linkTo={`/projects/${projectId}`}>
              Go to project
            </AppLinkButton>
          </div>
        </ModalContent>
      </div>
    </SuperModal>
  );
};

export default ProjectRateChangeWarning;
